var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('detail-view',{attrs:{"endpoint":_vm.endpoint + 'organizations',"name":"Organization","parentRoute":"organizations","permissions":"organizations","values":_vm.values}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9c99db2a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrganizationEdit.vue
// module id = PeDg
// module chunks = 1